import styled, { css } from 'styled-components'

import { DASHBOARD_STYLED_CONSTS } from '@components'
import { mediaQueries } from '@fourthwall/components'

const ASIDE_WIDTH = 250

export const Container = styled.div`
  height: 100%;
  max-height: fit-content;
  display: flex;
  flex-direction: column;
  gap: var(--space-500);
`

export const Inner = styled.div`
  width: 100%;
  height: 100%;
  max-height: fit-content;
  display: flex;
  align-items: flex-start;
  position: relative;

  ${mediaQueries.tablet} {
    max-height: none;
  }
`

export const Content = styled.div<{ hasAside: boolean }>`
  width: 100%;
  max-width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-500);
  will-change: max-width;
  transition: max-width 0.3s ease-out;

  ${({ hasAside }) =>
    hasAside &&
    css`
      max-width: calc(100% - ${ASIDE_WIDTH}px - var(--space-500));
    `}
`

export const SidebarTrack = styled.div<{ visible: boolean }>`
  position: sticky;
  height: calc(100vh - ${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px - var(--space-500) * 2);
  top: calc(${DASHBOARD_STYLED_CONSTS.HEADER_HEIGHT}px + var(--space-500));
  max-width: 0;
  width: ${ASIDE_WIDTH}px;
  transition: max-width 0.3s ease-out;
  z-index: 0;
  pointer-events: none;
  will-change: max-width;
  transform: translateZ(0);

  ${({ visible }) =>
    visible &&
    css`
      max-width: ${ASIDE_WIDTH}px;
      margin-left: var(--space-500);
      pointer-events: auto;
    `}
`

export const SidebarPositioner = styled.div`
  position: absolute;
  right: -${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL_LAPTOP}px;
  top: 0;
  height: 100%;
  width: calc(${ASIDE_WIDTH}px + ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL_LAPTOP}px);
  overflow: hidden;
`

export const SidebarPanel = styled.div<{ visible: boolean }>`
  position: absolute;
  top: 0;
  width: ${ASIDE_WIDTH}px;
  pointer-events: auto;
  transform: translateX(
    calc(100% + ${DASHBOARD_STYLED_CONSTS.CONTENT_PADDING_HORIZONTAL_LAPTOP}px)
  );
  transition: transform 0.3s ease-out;
  height: fit-content;
  max-height: 100%;
  border: 1px solid var(--border-secondary);
  border-radius: var(--radius-brand);
  overflow: auto;

  ${({ visible }) =>
    visible &&
    css`
      transform: translateX(0);
    `}
`
